import { config } from '@/config';
import { useAuth } from './auth';

export const useRefinement = () => {
    const { getAuthHeaders } = useAuth();

    /**
     * Refine and polish blog post content to publication quality
     * @param {string} id - Post ID
     * @param {string} instructions - User's refinement instructions/request
     * @param {Object} options - Refinement options
     * @param {boolean} options.refine_content - Refine full content
     * @param {boolean} options.improve_title - Improve title
     * @param {boolean} options.refine_excerpt - Refine excerpt
     * @param {boolean} options.refine_tags - Refine tags
     * @returns {Promise<Object>} Refinement result with refined_content, improved_title, refined_excerpt, refined_tags, changes_summary, and metadata
     */
    const refineContent = async (id, instructions, options = {}) => {
        try {
            const requestBody = {
                instructions: instructions,
                options: {
                    refine_content: options.refine_content ?? true,
                    improve_title: options.improve_title ?? true,
                    refine_excerpt: options.refine_excerpt ?? true,
                    refine_tags: options.refine_tags ?? true,
                },
            };

            const response = await fetch(
                `${config.API_BASE_URL}/api/v1/admin/posts/${id}/ai-refinement`,
                {
                    method: 'POST',
                    headers: getAuthHeaders(),
                    body: JSON.stringify(requestBody),
                }
            );

            if (response.ok) {
                return await response.json();
            } else {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to refine content');
            }
        } catch (error) {
            console.error('Error refining content:', error);
            throw error;
        }
    };

    return {
        refineContent,
    };
};
